import { render } from "./SmallCard.vue?vue&type=template&id=e8e157fa&scoped=true"
import script from "./SmallCard.vue?vue&type=script&lang=js"
export * from "./SmallCard.vue?vue&type=script&lang=js"

import "./SmallCard.vue?vue&type=style&index=0&id=e8e157fa&scoped=true&lang=css"

import exportComponent from "D:\\eestec sajt trenutni\\eestec.etf.rs\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8e157fa"]])

export default __exports__